import { createGlobalStyle as s, css as t } from "styled-components";
const l = s`
  body {
    ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.body.expressive")) == null ? void 0 : r.toJS();
}}

    background-color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.colors.black")};
    color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.primary.default")};
  }

  a {
    color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.primary.default")};
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 0.2em;

    &:hover {
      color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.primary.hover")};
    }
  }

  /* Storybook-specific overrides. */
  ${({ theme: o }) => {
  const r = o == null ? void 0 : o.get("tokens.colors.black");
  return r === "rgb(15 15 15)" ? null : t`
      #anchor--components-inputs-textinput--default .docs-story.docs-story,
      body.sb-show-main.sb-show-main {
        background-color: ${r} !important;
      }
    `;
}}
`;
export {
  l as GlobalStyles
};
